import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-cancela-ticket',
  templateUrl: './cancela-ticket.component.html',
  styleUrls: ['./cancela-ticket.component.css']
})
export class CancelaTicketComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  qrcode:string="";
  motivos:string="";
  tiempoMsg:number=3200;
  resultado:any=[];
  consolidaCan:boolean = false;
  folioIni:number = -1;
  folioFin:number = -1;

  enviandoCorreo:number=-1;
  admonCorreo:any=[];
  envioMail:any;
  agruparTickets:boolean=false;

  thisForm = new FormGroup({
    motivo: new FormControl(this.motivos, []),
  });


  
  constructor(private dataService: DataService, public dialogRef: MatDialogRef<CancelaTicketComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    //console.log(this.data.item)
    if(this.data){
      this.agruparTickets = this.data.grupo;
      if(this.agruparTickets){
        console.log(this.data);
        setTimeout(() => {
          var auxChk = <HTMLInputElement>document.getElementById("chkConsolida");
          auxChk.checked = true;
          auxChk.style.visibility = "hidden";
          this.fnConsolidaCancelacion(auxChk);            
        }, 150);
      }
      //else{
        this.qrcode = "F" + this.data.item.folio + "|" + this.data.item.fecha_emi + "|" + this.data.item.hora_emi;
      //}
    }

    this.dataService.getVars("ENV_LOG").subscribe(
      rows => {   
              this.enviandoCorreo = <any>rows
              },          
      error => this.errMsg = <any>error,
      () => this.fnEnvio_Correo_Log_Obtenido());  
  }

  fnEnvio_Correo_Log_Obtenido(){
    //console.log(this.enviandoCorreo);
    if(this.enviandoCorreo == 1){
      //this.correoLog = this.enviandoCorreo[0].;
      this.dataService.getEnvioLog().subscribe(
                          rows => {   
                                  this.admonCorreo = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnAdmonLogObtenido());
    }
  }

  fnAdmonLogObtenido(){
    //console.log(this.admonCorreo);
  }

  fnKeyPress(t, e){
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  fnConsolidaCancelacion(item){
    setTimeout(() => {
      if(item.checked){
        this.consolidaCan=true;
        this.folioIni = this.data.item.folio - this.data.item.i + 1;
        this.folioFin = this.folioIni + this.data.item.n - 1;

      }
      else{
        this.consolidaCan=false;
      }
    }, 50); 
  }


  fnMuestraMensaje(tipo:string, msg:string, changeLoading:boolean, closeDialog:boolean){
    this.okMsg = "";
    this.errMsg = "";
    if(tipo=="OK")
      this.okMsg = msg;
    if(tipo=="ERR")
      this.errMsg = msg;
    setTimeout(() => {
      this.okMsg = "";
      this.errMsg = "";
      if(changeLoading)
        this.loading = !this.loading;
      if(closeDialog)
        this.dialogRef.close();
    }, this.tiempoMsg);
  }

  fnCancelar(){
    //console.log("CANCELANDO!")
    if(!this.consolidaCan){
      if(this.agruparTickets){
        this.data.id = this.data.item.minId;
      }
      this.dataService.insLog(41,'CANCELA', "" + this.data.item.folio,'').subscribe(
                              row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
      this.dataService.canTicket(this.data.id, this.thisForm.controls["motivo"].value).subscribe(
                                rows => {   
                                        this.resultado = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnTicketCacelado(this.data.item.folio));              
    }
    else{
      this.dataService.insLog(41,'CANCELA', "" + this.folioIni + " al " + this.folioFin,'').subscribe(
                              row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );   
      var idIni = this.data.id - this.data.item.i + 1;
      var idFin = idIni + this.data.item.n - 1;
      if(this.agruparTickets){
        idIni = this.data.item.minId;
        idFin = this.data.item.maxId;
      }
      this.dataService.canTickets(idIni, idFin, this.thisForm.controls["motivo"].value).subscribe(
                                rows => {   
                                        this.resultado = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnTicketCacelado(this.folioIni + " al " + this.folioFin));              
    }
  }

  fnTicketCacelado(folio:string){
    //console.log(this.resultado)
    if(this.resultado > 0){
      if(this.admonCorreo.length > 0){    
        var msg = "Folio: '" + folio + "'∙";
        msg += "Motivo: '" + this.thisForm.controls["motivo"].value + "'∙";
        this.dataService.sendMailLog("Folio Cancelado » '" + folio + "'.", msg, this.admonCorreo[0].mail, this.admonCorreo[0].nombre).subscribe(
                              rows => {   
                                      this.envioMail = rows
                                      },          
                              error => this.errMsg = <any>error,
                              () => this.fnEmailEnviado());     
      }
      if(this.consolidaCan)
        this.fnMuestraMensaje("OK", "Tickets cancelados", false, true);
      else
        this.fnMuestraMensaje("OK", "Ticket cancelado", false, true);
    }
    else{
      if(this.consolidaCan)
        this.fnMuestraMensaje("ERR", "Error al cancelar tickets", true, false);
      else
        this.fnMuestraMensaje("ERR", "Error al cancelar ticket", true, false);
      setTimeout(() => {
        this.loading = false;
      }, this.tiempoMsg);
    }
  }

  fnEmailEnviado(){
    console.log("Correo enviado")
  }
}
